/**
 * Helpers pour déterminer le type de plan utilisateur
 * 
 * NOTE: This file re-exports from the centralized planFrequency utility
 * for backward compatibility. New code should import directly from @/lib/planFrequency
 */

import {
  isPresencePlan as _isPresencePlan,
  isEmergencePlan as _isEmergencePlan,
  isAccelerationPlan as _isAccelerationPlan,
} from '@/lib/planFrequency';

export { planToFrequency } from '@/lib/planFrequency';

/**
 * Vérifie si un plan est de type "présence" (avec ou sans multihook)
 * Les plans présence n'ont pas accès au cross-post Agence Personnelle
 */
export function isPresencePlan(plan: string | null | undefined): boolean {
  return _isPresencePlan(plan);
}

/**
 * Vérifie si un plan est de type "émergence" (avec ou sans multihook)
 */
export function isEmergencePlan(plan: string | null | undefined): boolean {
  return _isEmergencePlan(plan);
}

/**
 * Vérifie si un plan est de type "accélération" (avec ou sans multihook)
 */
export function isAccelerationPlan(plan: string | null | undefined): boolean {
  return _isAccelerationPlan(plan);
}

/**
 * Vérifie si la fréquence globale correspond à un plan présence
 * Présence = 1 vidéo/semaine
 */
export function isPresenceFrequency(frequency: number | null | undefined): boolean {
  return frequency === 1;
}

/**
 * Vérifie si l'utilisateur a accès au cross-post Agence Personnelle
 * Basé sur le plan OU la fréquence (les deux méthodes sont valides)
 */
export function hasApCrosspostAccess(
  plan: string | null | undefined, 
  frequency?: number | null | undefined
): boolean {
  // Si on a le plan explicite, l'utiliser
  if (plan) {
    return !isPresencePlan(plan);
  }
  // Sinon, utiliser la fréquence si disponible
  if (frequency !== undefined && frequency !== null) {
    return !isPresenceFrequency(frequency);
  }
  // Par défaut, pas d'accès (sécurité)
  return false;
}

